import { AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { transform } from 'lodash';


declare const madeCircle: any;

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ["./main.component.css"],
})
export class MainComponent implements AfterViewInit {

  clearTimer:any;
  slideIndex:number = 0;

  constructor(
    private elementRef:ElementRef
    ) { }

  ngAfterViewInit() {
    this.clearTimer = madeCircle();
 
    }


  scrollTop(){
    window.scrollTo(0,0);
  }

  ngOnInit(): void {
  
  }
  

  ngOnDestroy(){
    clearInterval(this.clearTimer);
  }

  nextBtn(){
    if(this.slideIndex<4){
      this.slideIndex++;  
      for(let i =0 ; i<5; i++){
        (document.querySelectorAll('.slide-content')[i] as HTMLElement).style.transform = "translateX(-" + 100*this.slideIndex + "%)";
      }
    }
  }
  prevBtn(){
    if(this.slideIndex>0){
      this.slideIndex--;
      for(let i =0 ; i<5; i++){
        (document.querySelectorAll('.slide-content')[i] as HTMLElement).style.transform = "translateX( -" + 100*this.slideIndex + "%)";
      }
    }
  }
}


